import React, { useState } from "react";

const PseudoStep = ({ onPseudoChosen }) => {
	const [pseudo, setPseudo] = useState("");

	return (
		<div className="flex flex-col items-center w-full h-full mt-16 min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			<h1 className="text-2xl text-gray-600 font-bold text-center mb-8">
				Choisissez un pseudo :
			</h1>
			<div className="w-full">
				<p className="text-md text-gray-700 my-3">Pseudo:</p>
				<input
					type="text"
					value={pseudo}
					onChange={(e) => setPseudo(e.target.value)}
					className="border border-gray-300 rounded px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-black"
				/>
			</div>
			<div className="flex flex-col gap-2 items-center mt-8">
				<button
					onClick={() => onPseudoChosen(pseudo)}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Valider
				</button>
			</div>
		</div>
	);
};

export default PseudoStep;
